import React from 'react'
import Header from '../Layout/Header'
import Footer from '../Layout/Footer'
import { Link } from 'react-router-dom'

function Contact() {
  return (
    <div>
         <Header/>       
        {/* <!-- Breadcrumb Section Start --> */}
        <div class="gt-breadcrumb-wrapper bg-cover"   style={{
    backgroundImage: "url('/assets/img/breadcrumb-bg.jpg')"
 
  }}>
            <div class="container">
                <div class="gt-page-heading">
                    <div class="gt-breadcrumb-sub-title">
                        <h1 class="wow fadeInUp" data-wow-delay=".3s">Contact Us</h1>
                    </div>
                    <ul class="gt-breadcrumb-items wow fadeInUp" data-wow-delay=".5s">
                        <li>
                            <Link to="/">
                                Home
                            </Link>
                        </li>
                        <li>
                            <i class="fa-solid fa-chevron-right"></i>
                        </li>
                        <li>
                           Contact Us
                        </li>
                    </ul>
                </div>
            </div>
        </div>

        {/* <!-- Contact INfo Section Start --> */}
        <section class="contact-info-section fix section-padding">
            <div class="container">
                <div class="contact-info-wrapper">
                    <div class="section-title text-center">
                        <h2>    
                            Contact Us for Furnished Home Tours
                        </h2>
                        <p class="mt-3">
                            Schedule a tour today and explore our fully furnished homes. Experience stylish, move-in-ready spaces designed for <br/> comfort, convenience, and modern living. Let us help you find your perfect fit.
                        </p>
                    </div>
                    <div class="row">
                        <div class="col-xl-4 col-lg-6 col-md-6">
                            <div class="contact-info-box">
                                <div class="icon">
                                   <i class="fa-solid fa-location-dot"></i>
                                </div>
                                <div class="content">
                                    <h3>Location</h3>
                                    <p> CHOMU TO CHANDWAJI, STATE HIGHWAY, MORIJA
TEH: CHOMU, DISTT.-JAIPUR (RAJ.) </p>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-4 col-lg-6 col-md-6">
                            <div class="contact-info-box">
                                <div class="icon">
                                  <i class="fa-solid fa-phone-xmark"></i>
                                </div>
                                <div class="content">
                                    <h3>Phone</h3>
                                    <a href="tel:+919799418563">+919799418563</a><br></br>
                                    <a href="tel:+919828551389">+919828551389</a>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-4 col-lg-6 col-md-6">
                            <div class="contact-info-box">
                                <div class="icon">
                                   <i class="fa-solid fa-envelopes"></i>
                                </div>
                                <div class="content">
                                    <h3>Location</h3>
                                    <a href="mailto:example@gmail.com">rsgurjar304030@gmail.com</a><br></br>
                                    <a href="mailto:example@gmail.com">jagdish281278@gmail.com</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        {/* <!-- Contact Section Start --> */}
        <section class="contact-section-3 fix section-padding pt-0">
            <div class="container">
                <div class="contact-wrapper-10">
                    <div class="section-title text-center mb-0">
                        <h5 class="wow fadeInUp"><i class="flaticon-home"></i> Keep In Touch <i class="flaticon-home"></i></h5>
                        <h2 class="wow fadeInUp" data-wow-delay=".3s">Get in Touch with Our Lovely Team</h2>
                    </div>
                    <form action="https://demo.scriptotheme.com/livesta/contact.php">
                    <div class="row g-4">
                        <div class="col-lg-6 wow fadeInUp" data-wow-delay=".2s">
                            <div class="form-clt">
                                <input type="text" name="name" id="name" placeholder="Full Name"/>
                            </div>
                        </div>
                        <div class="col-lg-6 wow fadeInUp" data-wow-delay=".4s">
                            <div class="form-clt">
                                <input type="text" name="email" id="email" placeholder="Email address"/>
                            </div>
                        </div>
                        <div class="col-lg-12 wow fadeInUp" data-wow-delay=".2s">
                            <div class="form-clt">
                                <div class="form">
                                    <select class="single-select w-100">
                                        <option>Real Estate</option>
                                        <option>Property management</option>
                                        <option>Market analysis</option>
                                        <option>Home interior</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-12 wow fadeInUp" data-wow-delay=".6s">
                            <div class="form-clt">
                                <textarea name="message" id="message" placeholder="Message Here*"></textarea>
                            </div>
                        </div>
                        <div class="col-lg-12 wow fadeInUp" data-wow-delay=".2s">
                            <button class="theme-btn" type="submit">
                                Send Message
                            </button>
                        </div>
                    </div>
                </form>
                </div>
            </div>
        </section>

        {/* <!-- Map Section Start --> */}
        <div class="googpemap-2">
         <iframe src="https://www.google.com/maps/embed?pb=!1m28!1m12!1m3!1d28398.36249570839!2d75.71343208517314!3d27.162729695906272!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!4m13!3e6!4m5!1s0x396daab6b24d6917%3A0xcf2220efaa8a3553!2sCHOMU!3m2!1d27.1655759!2d75.7158062!4m5!1s0x396dabb2f8d64dc7%3A0x570073303cd9bc6e!2sMorija%20chandwaji%20road%20Chomu%2C%205Q52%2BCJC%2C%20Morija%2C%20Rajasthan%20303805!3m2!1d27.1586748!2d75.7523097!5e0!3m2!1sen!2sin!4v1759132955933!5m2!1sen!2sin"  style={{ border: 0 }}  allowfullscreen="" loading="lazy"></iframe>
        </div>
 <Footer/>
    </div>
  )
}

export default Contact
